// extracted by mini-css-extract-plugin
export var allAppsLink = "index-module--allAppsLink--Tkv46";
export var contactButton = "index-module--contactButton--6u64O";
export var contactWrapper = "index-module--contactWrapper--X1T5b";
export var section = "index-module--section--Xy91R";